import React from 'react';
import propTypes from 'prop-types';

const Column = props => {
  const { render } = props;
  return <div>{render()}</div>;
};

Column.propTypes = {
  render: propTypes.func.isRequired,
};

export default Column;
